import React from "react";
import { getCurrentFormattedDate, getTimeOfDay } from "../../utils";
import { useSelector } from "react-redux";

function Heading() {
  const { user } = useSelector((state) => state.auth);
 
  return ( 
    <div className="  flex flex-col justify-center items-center h-auto">
      <div className="w-full flex lg:flex-row flex-col   space-x-2">
        <span className="text-blackest text-[30px] font-bold dash-title ">
          Good {getTimeOfDay()},
        </span>
        <span className="text-blueDark text-[30px] font-bold dash-title ">
          {user?.sub ?? user?.iss}
        </span> 
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            width="50px"
            height="50px"
            className="waving-hand"
            style={{ transformOrigin: "70% 70%" }}
          >
            <text x="0" y="55" fontSize="40">
              👋
            </text>
            <style>
              {`
                .waving-hand {
                  animation: wave 2s infinite;
                }
  
                @keyframes wave {
                  0% { transform: rotate(0deg); }
                  10% { transform: rotate(14deg); }
                  20% { transform: rotate(-8deg); }
                  30% { transform: rotate(14deg); }
                  40% { transform: rotate(-4deg); }
                  50% { transform: rotate(10deg); }
                  60% { transform: rotate(0deg); }
                  100% { transform: rotate(0deg); }
                }
              `}
            </style>
          </svg>
       
      </div>
  
      <div className="text-lg font-normal leading-normal w-full">
        It’s {getCurrentFormattedDate()}
      </div>
    </div> 
  
  );
}

export default Heading;
